export const MEDICAL_EXAMS_BASE_PATH = '/enviar-exames';

export const MAX_MEDICAL_EXAM_FILES = 10;

export const ACCEPTED_MEDICAL_EXAM_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
] as const;

export const ACCEPTED_MEDICAL_EXAM_ACCEPT_ATTR = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';

export const MEDICAL_EXAM_TYPE_LABEL: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/jpeg': 'JPG',
  'image/jpg': 'JPG',
  'image/png': 'PNG',
};
